var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-menu',{staticClass:"tab-menu",class:_vm.classObj,attrs:{"panes":_vm.getVisitedViews,"current-name":_vm.currentName,"current-params":_vm.currentParams,"current-query":_vm.currentQuery},on:{"close-other":_vm.closeOther,"close-all":_vm.closeAll,"tab-remove":_vm.removeTab,"tab-click":_vm.clickTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }